import { GATrackingEvent, GATrackingEventPayload } from '~shared/modules/ga-tracking/models';
import {
  GATrackingEventType,
  GaTrackingEventCategory,
  GaTrackingEventName,
} from '~shared/modules/ga-tracking/constants';
import { Product } from '~app/modules/account/modules/buy-again/models';

export class GATrackingExploreSimilarProductsBuyAgainInteractionEvent implements GATrackingEvent {
  constructor(private product: Product) {}

  getEventType(): any {
    return GATrackingEventType.ProductClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.ExploreSimilarProductsBuyAgainClickInteraction,
      category: GaTrackingEventCategory.Interaction,
      action: GaTrackingEventName.ExploreSimilarProductsBuyAgainClickInteraction,
      label: this.product.id,
    };
  }
}
